<div>Report: {{path}}</div>